// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiMedical {
    'memberId'?: string;
    'payorId'?: string;
    'payorName'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiMedical>> = [
        {
            "name":     "memberId",
            "baseName": "memberId",
            "type":     "string"
        },
        {
            "name":     "payorId",
            "baseName": "payorId",
            "type":     "string"
        },
        {
            "name":     "payorName",
            "baseName": "payorName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiMedical.attributeTypeMap;
    }
}
